import {useLocation} from "react-router-dom";
import * as React from "react";
import {ReactElement, useEffect, useState} from "react";
import PageNotFound from "../error/notFound/pageNotFound";
import AnswerTextComponent from "../advice/answerText";
import AnswerGroupComponent from "../advice/answerGroup";
import {useTranslation} from "react-i18next";
import axios from "axios";
import AssessmentResults from "../../dynamic-components/body/AssessmentResults";
import InformationTable from "../../dynamic-components/table/InformationTable";
import SummaryWithChart from "../../dynamic-components/section/SummaryWithChart";
import HighSkill from "../../dynamic-components/section/HighSkill";
import LowSkill from "../../dynamic-components/section/LowSkill";
import RedirectMenu from "../../dynamic-components/section/RedirectMenu";
import Comparison from "../../dynamic-components/section/Comparison";
import RecommendTable from "../../dynamic-components/table/RecommendTable";
import MultiLevelDynamicRenderer from "../../dynamic-components/body/DynamicRenderer";
import Summary from "../../dynamic-components/section/Summary";

interface AdviceResponse {
    title: string,
    questions?: question[],
    groups: group[],
    highSkills?: group[];
    lowSkills?: group[];
    comparison?: group[];
    feedback?: string
    templateAnswerResult?: string
    activeTemplate?: boolean,
    answerTime?: string,
    feedbackAssisstant: Map<string, string>
}

interface question {
    title: string,
    answer: string,
    type: number
}

interface group {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string,
}
export default function Advice() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const uri = queryParams.get('uri');
    const id = queryParams.get('id');
    const [response , setResponse] = useState<AdviceResponse|null>();
    const [componentMap , setComponentMap] = useState<Record<string, ReactElement>>();
    const { t } = useTranslation();
    const [notExist, setNotExist] = useState(false);

    let questionNo = 0;
    let groupNo = 0;

    useEffect(() => {
        if (uri !== null && id !== null) {
            axios.get(`${process.env.REACT_APP_API_ENDPOINT || ""}api/v1/advices?uri=${uri}&id=${id}`)
                .then(res => {
                    if(res.data !== ''){
                        const feedbackMap = new Map(Object.entries(res.data.feedbackAssisstant));
                        res.data.feedbackAssisstant = feedbackMap;
                        setResponse(res.data);
                        const componentMap = {
                            INFORMATION: <InformationTable data={res.data} />,
                            SUMMARY_WITH_CHART: <SummaryWithChart data={res.data} />,
                            HIGH_SKILLS: <HighSkill data={res.data} />,
                            LOW_SKILLS: <LowSkill data={res.data} />,
                            MENU: <RedirectMenu />,
                            COMPARISON: <Comparison data={res.data} />,
                            RECOMMENDED: <RecommendTable />,
                            SUMMARY: <Summary data={res.data.feedbackAssisstant.get('4') != null ? res.data.feedbackAssisstant.get('4') : ''}/>
                        };
                        setComponentMap(componentMap)
                    }
                    else {
                        setNotExist(true);
                    }
                })
        } else {
            setNotExist(true)
        }
    }, [uri, id]);

    return (
        <>
            { response && !response.activeTemplate ?
                <div className="container acf-wrap">
                    <h2><span dangerouslySetInnerHTML={{ __html: response.title || '' }}/></h2>
                    <p className="acf-comp-ttl">{t('title-score-and-advice')}</p>
                    <div className="acf-score">
                        {
                            response.questions?.map(item => {
                                questionNo++;
                                return <AnswerTextComponent title={item.title} questionNo={questionNo} required={true} text={item.answer}/>
                            })
                        }
                        {
                            response.groups?.map(item => {
                                groupNo++;
                                return <AnswerGroupComponent
                                    numberOfQuestion={item.totalQuestion}
                                    title={item.groupTitle}
                                    groupNo={groupNo}
                                    totalPoint={item.totalPoint}
                                    advice={item.advice}
                                    key={`group${groupNo}`}/>
                            })
                        }
                    </div>
                    {
                        response.feedback &&
                            <div className="feedback-gpt">
                                <div className="acf-sect">
                                    <h4 className="acf-sect-header"><p className="feedback-header">{t('feedback-chatgpt')}</p></h4>
                                    <pre style={{whiteSpace: 'break-spaces'}} dangerouslySetInnerHTML={{ __html: response.feedback || '' }} />
                                </div>
                            </div>
                    }
                </div> : <></>
            }
            {
                response && response.activeTemplate && response.templateAnswerResult == null &&
                // <div className="container acf-wrap" dangerouslySetInnerHTML={{ __html: response.templateAnswerResult }} />
                <AssessmentResults data={response}/>
            }
            {
                response && response.activeTemplate && response.templateAnswerResult != null && response.templateAnswerResult !== '' && componentMap &&
                <div className="container acf-wrap">
                    <div style={{ maxWidth: '1000px', margin: '0 auto', fontFamily: '源ノ角ゴシック JP'}}>
                        <h1 className={'p-5'} style={{ textAlign: 'center', fontSize: '25px', fontWeight: 'bold', color:'#232323' }}>リスキリングアセスメント結果</h1>
                        <div>
                            <MultiLevelDynamicRenderer template={response.templateAnswerResult} componentMap={componentMap}/>
                        </div>
                    </div>
                </div>

            }
            {
                notExist ? <PageNotFound/> : <></>
            }

        </>
    );
}
